import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import alert from '../../../pages/client/client_assets/img/red_alert.svg';
import axios from 'axios';
import logo from '../../../pages/client/client_assets/img/logo.svg';
import menu1 from '../../../pages/client/client_assets/img/menu1.svg';
import menu3 from '../../../pages/client/client_assets/img/menu3.svg';
import config from '../../../../src/config/config.js';
import '../../../pages/client/client_assets/css/sidebar.css';

const SideBar = () => {
  // const [isSidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation(); 
  const navigate = useNavigate();
  const [role, setrole] = useState(''); 

  const [isPricingCollapsed, setPricingCollapsed] = useState(false); // Set initial state to false

  const handlePricingCollapseToggle = () => {
    setPricingCollapsed((prevState) => !prevState);
  };


  // Logout Popup
  const [modalShow, setModalShow] = useState(false);

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="logout_popup"
      >
        <Modal.Body>
          <img src={alert} alt="" />
          <p>Oh no! You’re about to log out from <strong>Brew Your Brand?</strong></p>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button onClick={props.onHide}>Keep Me Logged In</Button>
          <Button onClick={handleLogout}>Log Me Out</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const handleLogout = async () => {
    try {
        const response = await axios.post(`${config.API_BASE_URL}/logout.php`, {}, { withCredentials: true });
        console.log(response.data.message);
        window.location.href = "/client"; // Redirect to login page
    } catch (error) {
        console.error("Logout failed:", error);
    }
};

  // const sideBarOpen = () => {
  //   setSidebarOpen(!isSidebarOpen);
  // };

  // Helper function to determine if a path is active
  function isActive(path, checkSubPaths = false) {
    if (checkSubPaths) {
      const surveyRoutes = ['/client/customer-form', '/client/employee-form', '/client/partner-form', '/client/investor-form'];
      return location.pathname.startsWith(path) || surveyRoutes.some(route => location.pathname.includes(route));
    }
    return location.pathname === path;
  }

  // Determine if the Pricing section should be active
  // const isPricingActive = ['/pricing', '/strategy', '/configure', '/optimize', '/price-performance', '/price-update', '/scenario-tracker'].includes(location.pathname);
  
  // Update pricing collapse state based on the active route
  // useEffect(() => {
  //   setPricingCollapsed(isPricingActive);
  // }, [location.pathname]);

  return (
    <>
      <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
        <a className="sidebar-brand d-flex align-items-center justify-content-left" href="/client/overview">
          <div className="sidebar-brand-icon rotate-n-15" >
            <img src={logo} alt='RapidPricer'/>
          </div>
        </a>
        
        <li className={`nav-item ${isActive('/client/overview') ? 'sidebaractive' : ''} disabled-link`}>
          <Link className="nav-link disabled-link" to="/client/overview">
            <img src={menu1} style={{ width: '15px' }} />
            <span>Overview</span>
          </Link>
        </li>

        <li className={`nav-item ${isActive('/client/surveys', true) ? 'sidebaractive' : ''}`}>
          <Link className="nav-link" to="/client/surveys">
            <img src={menu3} style={{ width: '15px' }} />
            <span>Survey</span>
          </Link>
        </li>

      

        <li style={{ marginTop: 'auto' }}></li>
        
        <li className="nav-item setting">
          <Link className="nav-link " to="/client/setting">
            <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/setting.svg" alt="Settings" className="set_icon" />
            <span style={{ color: '#fff' }}>Settings</span>
          </Link>
        </li>
        
        <li className="nav-item border-0 logout">
          <Link className="nav-link" onClick={() => setModalShow(true)}>
            <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logout.svg" alt="Logout" className="set_icon" />
            <span style={{ color: '#fff' }}>Logout</span>
          </Link>
        </li>

        

      </ul>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default SideBar;
